import { t } from 'i18next'
import React from 'react'

const SearchResultAmount = ({ count }) => {
  if (typeof count !== 'number' || count <= 0) return null

  return (
    <div className='mt-2' style={{ color: 'gray' }}>
      {`${count} ${t('result', { count })}`}
    </div>
  )
}

export default SearchResultAmount
